import * as React from 'react';
import { Tooltip as ToolTipMaterial } from '@mui/material';
import './Tooltip.scss';

interface ToolTipInterface {
  children: React.ReactElement<any, any>;
  title: string;
  placement?:
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | undefined;
  disableHoverListener?: boolean;
}

const Tooltip = ({
  children,
  title,
  placement = 'top-start',
  disableHoverListener = false,
}: ToolTipInterface) => {
  return (
    <ToolTipMaterial
      disableHoverListener={disableHoverListener}
      placement={placement}
      arrow
      title={title}
    >
      {children}
    </ToolTipMaterial>
  );
};

export default Tooltip;
